import React, { Component } from 'react';
import { Divider, Button } from 'semantic-ui-react'
import * as moment from 'moment';
import axios from 'axios'
import { serverIp } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Form } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants';


class AddCouponToOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderType: '',
            orderTypeChoices: [],
            loading: false,
            couponCode: ''
        }
    }

    componentDidMount() {
        //SHIRT COLORS

    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    setCouponCode = () => {
        console.log("this.props.order.key:" + this.props.order.key);
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            couponCode: this.state.couponCode,
            // lastUpdated: now,
            // lastUpdatedBy: this.props.user.email,
            couponValid: "true",
            coupon: this.state.couponCode
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    checkCoupon = () => {
        console.log("cpx1 ======checkCoupon");

        this.setState({ loading: true })

        axios.post(serverIp + 'coupon/addCouponToOrder', {
            apiKey: "asdfasdf@a",
            fbOrderKey: this.props.order.key,
            couponCode: this.state.couponCode,
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");
                    this.setCouponCode();
                    alert("SUCCESS! COUPON SET");
                } else {
                    console.log("FAILED");
                    alert("FAILED TO SET COUPON:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const checkButton = this.state.couponCode.length === 5
            ? <Button onClick={this.checkCoupon}>CHECK COUPON</Button>
            : ''

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :

                <div>
                    <Divider horizontal>{'COUPON CODE!'}</Divider>
                    <Form>
                        <Form.Field>
                            <Form.Input
                                name={'couponCode'}
                                value={this.state.couponCode}
                                placeholder='Coupon Code (FIVE DIGITS):'
                                onChange={this.handleTextInputChange}
                            />
                        </Form.Field>
                        {checkButton}
                    </Form>
                </div>
        )
    }
}

export default AddCouponToOrder;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/AddCouponToOrder/AddCouponToOrder.js